import { template as template_98cba8b67d9f4bca995d28486bc5127e } from "@ember/template-compiler";
import { service } from '@ember/service';
import Component from '@glimmer/component';
import BsButton from 'eflex/components/bs-button';
import { t } from 'ember-intl';
import BsDropdown from 'ember-bootstrap/components/bs-dropdown';
import FaIcon from '@fortawesome/ember-fontawesome/components/fa-icon';
import BsTooltip from 'eflex/components/bs-tooltip';
export default class InputsLayerArrangement extends Component {
    @service
    imageEditor;
    sendToBack = ()=>{
        const activeObject = this.imageEditor.canvas.getActiveObject();
        this.imageEditor.sendToBack(activeObject);
    };
    bringToFront = ()=>{
        const activeObject = this.imageEditor.canvas.getActiveObject();
        this.imageEditor.bringToFront(activeObject);
    };
    static{
        template_98cba8b67d9f4bca995d28486bc5127e(`
    <div class="component-inputs-layer-arrangement" ...attributes>
      <BsDropdown
        @direction="bottom"
        class="layer-arrangement-dropdown z-2"
      as |dd|>
        <dd.toggle class="btn-dropdown {{if @disabled "pe-none"}}">
          <BsButton
            @type="peripheral"
            @disabled={{@disabled}}
            class="d-flex border-0 {{if @disabled "text-gray-500"}}"
          >
            <FaIcon @icon="layer-group" class="fa-fw" />
            <BsTooltip @title={{t "arrange"}} @delayShow={{600}} />
          </BsButton>
        </dd.toggle>

        <dd.menu class="dropdown-menu z-2" as |menu|>
          <div class="py-1 border-bottom border-gray-200">
            <menu.item>
              <BsButton
                class="app-layer-backward dropdown-item"
                @type="secondary"
                @size="sm"
                @onClick={{this.imageEditor.sendActiveBackwards.perform}}
                @disabled={{@disabled}}
              >
                {{t "backward"}}
              </BsButton>
            </menu.item>
            <menu.item>
              <BsButton
                class="app-layer-forward dropdown-item"
                @type="secondary"
                @size="sm"
                @onClick={{this.imageEditor.bringActiveForward.perform}}
                @disabled={{@disabled}}
              >
                {{t "forward"}}
              </BsButton>
            </menu.item>
          </div>
          <div class="py-1 border-bottom border-gray-200">
            <menu.item>
              <BsButton
                class="app-layer-back dropdown-item"
                @size="sm"
                @onClick={{this.sendToBack}}
                @disabled={{@disabled}}
              >
                {{t "back"}}
              </BsButton>
            </menu.item>
            <menu.item>
              <BsButton
                class="app-layer-front dropdown-item"
                @size="sm"
                @onClick={{this.bringToFront}}
                @disabled={{@disabled}}
              >
                {{t "front"}}
              </BsButton>
            </menu.item>
          </div>
        </dd.menu>
      </BsDropdown>
    </div>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
